module.exports = __webpack_public_path__ + "static/img/纪检监察.62d204f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/纪检监察.png
// module id = 6iC0
// module chunks = 1